import React from "react";
import { Route, Routes } from "react-router-dom";
import { StockCategoriesAndTagsList } from "./containers";

export const StockCategoriesAndTags = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<StockCategoriesAndTagsList />} />
      </Routes>
    </>
  );
};
